import React, { useEffect, useState, useCallback, useRef, useContext } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from ".././../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from "react-redux";
import Navigationtitle from "../include/Navigationtitle";
import DataService from ".././../services/tutorial.service";
import { playerlistData, setisfirsttime, actlistData } from "../../actions/index";
import Demo from "../crop/Demo";
import { decode } from "base-64";
import { FirebaseContext } from '../../FirebaseContext';

import { Image, Shimmer } from "react-shimmer";
import { playerdefaultLogo } from "../../constants/Images";
import { useMediaQuery } from "react-responsive";
import $ from "jquery";
import moment from "moment";
import { getDatabase, ref, remove, onValue, set, update } from "firebase/database";
import ImageCropper from "../cropper/ImageCropper";
import { bat } from "../../constants/Images";
import { ball } from "../../constants/Images";
import { wkeeper } from "../../constants/Images";
function Editplayers(match) {
  const dispatch = useDispatch();
  const getpageData = useSelector((state) => state.setplayerlistData);
  const getTeamList = useSelector((state) => state.setteamlistData);
  const getaucpageData = useSelector((state) => state.setactlistData);

  const [startDate, setStartDate] = useState(new Date());
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const [isDisabled, setDisabled] = useState(false);
  const loginuser = useSelector((state) => state.setUserlog);
  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const [sp3, setsp3] = useState("");
  const [othersp3, setOthersp3] = useState(false);
  const [auctype, setauctype] = useState(localStorage.getItem('auction_type'))

  const [batting, setBatting] = useState("");
  const [other, setother] = useState("");
  const [other2, setother2] = useState("");
  const [other3, setother3] = useState("");
  const [bowling, setBowling] = useState("");
  const [otherBatting, setOtherBatting] = useState(false);
  const [otherBowling, setOtherBowling] = useState(false);
  const [croppedImage, setCroppedImage] = useState("");
  const [defimg, setdefimg] = useState(playerdefaultLogo);

  const [playimg, setPlayimg] = useState(null);

  const [isOwner, setIsOwner] = useState("");
  const [defaultIsOwner, setDefaultIsOwner] = useState(false);
  const [isNonPlayer, setIsNonPlayer] = useState(false);

  const [playingStyle, setPlayingStyle] = useState("");

  const [isbat, setisbat] = useState(false);
  const [isbol, setisbol] = useState(false);
  const [iswkeep, setiswkeep] = useState(false);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });

  const history = useHistory({ forceRefresh: true });
  const { pid } = useParams();
  const aid = localStorage.getItem("auction_id");
  const [cid, setCid] = useState(loginuser["cid"] || 0);
  const [catData, setcatData] = useState([]);
  const [catid, setcatid] = useState("");
  const [tagid, settagid] = useState("0");
  const [sp1opt, setsp1opt] = useState(['All Rounder', 'Batting All Rounder', 'Bowling All Rounder', 'All Rounder Wicketkeeper', 'Batsman', 'Bowler', 'Wicket Keeper', 'Batter', 'Other']);

  const updtoken = useSelector((state) => state.updtoken);
  const [sp2opt, setsp2opt] = useState(['Right Hand', 'Left Hand', 'Right Hand Batsman', 'Left Hand Batsman', 'Right Hand Opener', 'Left Hand Opener', 'Right Hand Middle Order', 'Left Hand Middle Order', 'Other']);
  const [sp3opt, setsp3opt] = useState(['Right Arm Fast', 'Right Arm Medium', 'Left Arm Fast', 'Left Arm Medium', 'Off-Break', 'Leg-Break', 'Left Arm Orthodox', 'Left Arm Chanaman', 'Other']);

  let logo_pic = "";


  const fetchcatData = async () => {
    console.log("andr aaaya")
    console.log(aid)
    // setActive(true);

    var hdr = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        "Authorization": JSON.stringify([{ 'cid': cid, 'token': loginuser["token"] }])
      }
    }

    await DataService.listCategory({ 'aid': aid }, hdr)
      .then(res => {

        let response = res.data;
        console.log(response);

        if (response.success == true) {

          let responsedata = response.data;
          console.log(" cat list kya h");
          console.log(responsedata);
          setcatData(responsedata.list);
        }
        // setActive(false);

      }).catch(() => {
        console.log('Not valid')
        // setActive(false);
      })
  };
  const onSubmit = (values) => {
    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });
    if (document.getElementById("logo_pic") != null) {
      logo_pic = document.getElementById("logo_pic").value;
    }
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
      },
    };
    var icon = ''
    if (isbat == true) {
      if (icon == '') {
        icon += 'bat.png'
      }
      else {
        icon += ',bat.png'
      }

    }
    if (isbol == true) {
      if (icon == '') {
        icon += "ball.png"
      }
      else {
        icon += ",ball.png"
      }

    }
    if (iswkeep == true) {
      if (icon == '') {
        icon += "gloves.png"
      }
      else {
        icon += ",gloves.png"
      }

    }

    values["icons"] = icon;
    values["logo_pic"] = croppedImage;
    values["isowner"] = isOwner;
    values["isnonplay"] = isNonPlayer;

    if(auctype==0){
      if (values.spcf1 !== 'Other') {
        setother('')
        values["spcf1"] = batting;
      }
      else {
        console.log('trigger')
        values["spcf1"] = other;
      }
      if (values.spcf2 !== 'Other') {
        setother2('')
        values["spcf2"] = bowling
      }
      else {
        values["spcf2"] = other2
  
      }
      if (values.spcf3 !== 'Other') {
        setother3('')
        values["spcf3"] = sp3
      }
      else {
        values["spcf3"] = other3
  
      }
    }
    


    // if (other !== "") {
    //   values["spcf1"] = other;
    // }
    // else {
    //   values["spcf1"] = batting;
    // }
    // if (other2 !== "") {
    //   values["spcf2"] = other2;
    // }
    // else {
    //   values["spcf2"] = bowling;
    // }



    values["chkowner"] = defaultIsOwner == true ? 1 : 0;
    if (values["ownertag"] == undefined) {
      values["ownertag"] = ""
    }
    console.log('submitted values')
    console.log(values)
    DataService.editPlayer(values, hdr)
      .then((res) => {
        let response = res.data;
        toast.dismiss(toastContainerId);

        console.log(response);

        if (response.success === true) {
          console.log(response.data, "fdsfsdf");
          toast.success(response.msg, {
            theme: "dark",
            position: "bottom-center",
          });
          const db = getDatabase();
          console.log(response.data.detail.img)
          set(ref(db, 'auction/info/' + aid), {
            "type": "4", "upd": "2", 'id': decode(pid), "detail": {
              "age": values.age,
              "base": values.base,
              "catid": values.catid ? values.catid : "",
              "fname": values.fname,
              "icons": values.icons,
              "detail": values.detail,
              "isnonplay": values.isnonplay,
              "isowner": values.isowner,
              "jrnm": values.jrno,
              "img": response.data.detail.img,
              "mob": values.mob,
              "ownertag": values.ownertag,
              "pcode": values.pcode,
              "pname": values.pname,
              "spcf1": values.spcf1,
              "spcf2": values.spcf2,
              "spcf3": values.spcf3,
              "trouser": values.trouser,
              "tshirt": values.tshirt,
            }, "tkn": updtoken
          });
          history.push(BASE_PATH + "auction-players");
          if (getpageData != 0) {
            const updateitem = getpageData.responsedata.list.filter(
              (ele, ind) => {
                if (ele.pid == values.pid) {
                  ele.pcode = values.pcode;
                  ele.mob = values.mob;
                  ele.pname = values.pname;
                  ele.fname = values.fname;
                  //ele.dob = values.dob;
                  ele.age = values.age;
                  ele.tshirt = values.tshirt;
                  ele.trouser = values.trouser;
                  ele.detail = values.detail;
                  if (
                    response.data.img != "" &&
                    response.data.img != null &&
                    response.data.img != "null"
                  ) {
                    ele.img = response.data.img;
                  }
                  ele.wkeep = values.wkeep;

                  if (values.isbatting != "" && values.batsmantyp != "") {
                    if (values.batsmantyp == "Other") {
                      ele.righthand = values.batsmantyp_other;
                    } else {
                      ele.righthand = values.batsmantyp;
                    }
                  } else {
                    ele.righthand = "";
                  }
                  if (values.isbowler != "" && values.bowling_type != "") {
                    if (values.bowling_type == "Other") {
                      ele.boller = values.other_bowling;
                    } else {
                      ele.boller = values.bowling_type;
                    }
                  } else {
                    ele.boller = "";
                  }
                }
                return ele;
              }
            );

            let responsedata = {
              responsedata: {
                path: getpageData.responsedata.path,
                aid: aid,
                list: updateitem,
              },
            };
            dispatch(playerlistData(responsedata));
          }
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        setDisabled(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });
  };

  const firechange = (datasnap) => {
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter((ele) => ele.aid != datasnap.id)

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + 'my-auction')
    }
  }

  useEffect(() => {

    fetchcatData(0);
    const updateitem = getpageData?.responsedata?.list?.filter((ele, ind) => {
      if (ele.pid == decode(pid)) {
        setBatting(ele.spcf1);


        console.log(ele)
        setValue("pcode", ele.pcode);
        setValue("mob", ele.mob);
        setValue("pname", ele.pname);
        setValue("fname", ele.fname);
        //setValue("dob", ele.dob);
        setValue("age", ele.age);
        setValue("plst", ele.plst);
        setValue("tshirt", ele.tshirt);
        setValue("trouser", ele.trouser);
        setValue("detail", ele.detail);
        setValue("spcf1", ele.spcf1);
        setValue("spcf2", ele.spcf2);
        setValue("spcf3", ele.spcf3);
        setBowling(ele.spcf2)
        setsp3(ele.spcf3)
        setValue("isnonplay", ele.isnonplay);
        setValue("isowner", ele.isowner);
        setValue("jrno", ele.jrno);
        setValue("jrnm", ele.jrnm);
        setValue("base", ele.base);
        if(catData !=''){
          setValue("catid", ele.catid);
        }

        console.log(ele.catid==0?"":ele.catid)
        setcatid(ele.catid)
        if (ele.ownertag != "" && ele.ownertag != null && ele.ownertag != "0") {
          settagid(ele.ownertag)

        }

        setIsOwner(ele.isowner);
        setDefaultIsOwner(ele.isowner >= 1 ? true : false);
        setIsNonPlayer(ele.isnonplay == 1 ? true : false);
        // setBowling(ele.spcf2);
        // setsp3(ele.spcf3);
if(auctype ==0){

        if (!sp1opt.includes(ele.spcf1)) {
          setValue("spcf1", "Other");

          setOtherBatting(true)
          setother(ele.spcf1)
          console.log(ele.spcf1)

        }
        if (ele.spcf1 == 'Bowler' || ele.spcf1 == 'Bowling All Rounder') {
          if (!sp3opt.includes(ele.spcf2)) {
            setBowling('Other')
            setValue("spcf2", "Other");
            setOtherBowling(true)
            console.log(ele.spcf2)

            setother2(ele.spcf2)
          }
          if (!sp2opt.includes(ele.spcf3)) {
            console.log('sp3 ')
            setValue("spcf2", "Other");
            setOthersp3(true)
            console.log(ele.spcf2)

            setsp3(ele.spcf3)
          }
        }
        else {
          if (!sp2opt.includes(ele.spcf2)) {
            setBowling('Other')
            console.log("sp2 other")
            setValue("spcf2", "Other");
            setOtherBowling(true)
            console.log(ele.spcf2)

            setother2(ele.spcf2)
          }
          console.log(ele.spcf3)

          if (!sp3opt.includes(ele.spcf3)) {
            // set
            setsp3('Other')
            setother3(ele.spcf3)
            console.log("sp2 other")
            setValue("spcf3", "Other");
            setOthersp3(true)
            console.log(ele.spcf2)

          }
        }
      }
        if (ele.icons !== '' && ele.icons !== null) {
          var styles = ele.icons.split(',')
          styles.forEach((ele) => {
            if (ele == 'ball.png') {
              console.log("trihh")
              setisbol(true)
            }
            else if (ele == 'bat.png') {
              console.log("trihh22")

              setisbat(true)
            }
            else {
              console.log("trihh33")

              setiswkeep(true)
            }
          })
        }
        // if(ele.img)

        if (ele.img != "" && ele.img != null) {
          // setPlayimg(`${getpageData.responsedata.path}${ele.img}`);
          setdefimg(getpageData.responsedata.path + ele.img)
        }
        // $(".crop-default img").attr(
        //   "src",
        //   ele.img
        //     ? `${getpageData.responsedata.path}${ele.img}`
        //     : playerdefaultLogo
        // );
      }
    });

    $(".crop-default").click(function () {
      $("#crop-pic").click();
    });
  }, [Demo]);

  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.upd == "4") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);

  // console.log(isOwner, "isOwner2");
  // console.log(defaultIsOwner, "default");
  var batstyle = {
    backgroundColor: 'white'
  }
  var bolstyle = {
    backgroundColor: 'white'
  }
  var wkeepstyle = {
    backgroundColor: 'white'
  }
  if (isbat == true) {
    batstyle = {
      // backgroundColor: 'black',
      // color: 'white',
      opacity: 1,
      border: '3px solid #3e71a3'
    }
  }
  if (isbol == true) {
    bolstyle = {
      // backgroundColor: 'black',
      // color: 'white',
      opacity: 1,
      border: '3px solid #3e71a3'
    }
  }
  if (iswkeep == true) {
    wkeepstyle = {
      // backgroundColor: 'black',
      // color: 'white',
      opacity: 1,
      border: '3px solid #3e71a3'
    }
  }
  return (
    <>
      <div>
        <Navigationtitle data={match} />

        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div className="row myclass1">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          action=""
                          autoComplete="off"
                          encType="multipart/form-data"
                        >
                          <input
                            type="hidden"
                            value={decode(pid)}
                            {...register("pid")}
                          />
                          <div className="row">
                            <div className="col-md-12">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4">
                                    {" "}
                                    <label htmlFor="crop-pic">
                                      {" "}
                                      Profile Pic{/*logo*/}{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <div style={{ clear: "both" }}></div>
                                    <ImageCropper
                                      croppedImage={croppedImage}
                                      setCroppedImage={setCroppedImage}
                                      defaultimage={defimg}
                                    />
                                    {/* {playimg != null ? (
                                      <Image
                                        className="user-pic"
                                        fallback={
                                          <Shimmer width={265} height={265} />
                                        }
                                        src={playimg}
                                      ></Image>
                                    ) : (
                                      <></>
                                    )} */}
                                  </div>
                                </div>
                              </div>
                              <div className="col-xs-12 col-md-6 ">
                                {/* <div className="col-md-12"> */}
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4">
                                    <label htmlFor="pcode"> Form No *</label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <input
                                      className="form-control"
                                      placeholder="Enter Form Number"
                                      type="text"
                                      {...register("pcode", {
                                        required: true,
                                        required: "required field.",
                                      })}
                                      id="pcode"
                                    />
                                    {errors.pcode && (
                                      <p className="text-error">
                                        {errors.pcode.message}
                                      </p>
                                    )}
                                  </div>
                                  {/* </div> */}
                                </div>
                                {/* <div className="col-md-12 margin-top-14px"> */}

                                {/* <div className="form-group text-box-margin">
                                  <div className="col-md-4  margin-top-14px">
                                    <label htmlFor="date">
                                      {" "}
                                      Date of Birth{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8  margin-top-14px">
                                    <input
                                      className="form-control"
                                      type="date"
                                      id="date"
                                      {...register("dob", {})}
                                    />
                                  </div>
                                </div> */}
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4 margin-top-14px">
                                    <label htmlFor="age">
                                      {" "}
                                      Age{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8  margin-top-14px">
                                    <input
                                      className="form-control"
                                      type="number"
                                      id="age"
                                      {...register("age", {})}
                                    />
                                  </div>
                                </div>
                                {/* </div> */}
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4">
                                    <label htmlFor="pname"> Name * </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <input
                                      className="form-control"
                                      placeholder="Enter Name"
                                      type="text"
                                      id="pname"
                                      {...register("pname", {
                                        required: true,
                                        required: "required field.",
                                      })}
                                    />
                                    {errors.pname && (
                                      <p className="text-error">
                                        {errors.pname.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4">
                                    <label htmlFor="fname"> Father Name </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <input
                                      className="form-control"
                                      placeholder="Enter Father Name"
                                      id="fname"
                                      type="text"
                                      {...register("fname", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px ">
                              <div className="col-md-12">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-2">
                                    <label htmlFor="mob"> Mobile No </label>
                                  </div>
                                  <div className="col-md-4 margin-left-6px">
                                    {" "}
                                    <input
                                      className="form-control"
                                      placeholder="Mobile number"
                                      id="mob"
                                      type="text"
                                      {...register("mob", {})}
                                    />
                                  </div>
                                  {catData != '' && <div className="col-md-6">
                                    <div className="form-group text-box-margin">
                                      <div className="col-md-4">
                                        <label htmlFor="trouser">
                                          {" "}
                                          Select Category{" "}
                                        </label>
                                      </div>
                                      <div className="col-md-8">
                                        <select
                                          className="form-control"
                                          type="text"
                                          {...register("catid")}
                                          value={
                                            catid
                                          }
                                          onChange={(e) => {
                                            setcatid(e.target.value);
                                          }}
                                        >
                                          <option value="" selected>
                                            Select category
                                          </option>
                                          {catData?.map(
                                            (ct) => (
                                              <option
                                                value={ct.cid}
                                                key={ct.cid}
                                              >
                                                {ct.cname}
                                              </option>
                                            )
                                          )}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                  }
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px">
                              <div className="col-md-12">
                                {" "}
                                <div className="form-group text-box-margin">
                                  <div className="col-xs-8 col-sm-3 col-md-2 margin-top-14px">
                                    {" "}
                                    <label htmlFor="isowner">
                                      {" "}
                                      Is Team Owner ?
                                    </label>
                                  </div>
                                  <div className="col-xs-3 col-sm-2 col-md-1">
                                    {" "}
                                    <input
                                      className="form-control"
                                      type="checkbox"
                                      id="isowner"
                                      checked={defaultIsOwner}
                                      value={isOwner}
                                      // {...register("isowner")}
                                      onClick={(e) =>
                                        setDefaultIsOwner(e.target.checked)
                                      }
                                    />
                                  </div>
                                  <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner">
                                    <select
                                      className="form-control"
                                      id="isowner"
                                      type="text"
                                      // {...register("isowner")}
                                      value={
                                        isOwner > 1 ? isOwner : "Select Team"
                                      }
                                      onChange={(e) => {
                                        setIsOwner(e.target.value);
                                      }}
                                      disabled={defaultIsOwner > 0 || defaultIsOwner ? false : true}
                                    >
                                      <option disabled selected>
                                        Select Team
                                      </option>
                                      {getTeamList?.responsedata?.list.map(
                                        (team) => (
                                          <option
                                            value={team.tid}
                                            key={team.tid}
                                          >
                                            {team.name}
                                          </option>
                                        )
                                      )}
                                    </select>
                                  </div>
                                  <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner">
                                    <select
                                      className="form-control"
                                      type="text"
                                      {...register("ownertag")}
                                      value={
                                        tagid
                                      }
                                      onChange={(e) => {
                                        settagid(e.target.value);
                                      }}
                                      disabled={defaultIsOwner > 0 || defaultIsOwner ? false : true}
                                    >
                                      <option value='0' selected>
                                        Select tag
                                      </option>
                                      <option value='1'>
                                        Owner
                                      </option>
                                      <option value='2' >
                                        Co-owner
                                      </option>
                                      <option value='3'>
                                        Icon
                                      </option>

                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {defaultIsOwner > 0 || defaultIsOwner ? (
                              <div className="col-md-12 margin-top-14px">
                                <div className="col-md-12">
                                  {" "}
                                  <div className="form-group text-box-margin">
                                    <div className="col-xs-8 col-sm-3 col-md-2 margin-top-14px">
                                      {" "}
                                      <label htmlFor="isnonplay">
                                        {" "}
                                        Is Non Playing Owner ?
                                      </label>
                                    </div>
                                    <div className="col-xs-3 col-sm-2 col-md-1">
                                      {" "}
                                      <input
                                        className="form-control"
                                        type="checkbox"
                                        checked={isNonPlayer}
                                        id="isnonplay"
                                        // {...register("isnonplay", {})}
                                        onClick={(e) =>
                                          setIsNonPlayer(e.target.checked)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}

                            {auctype==0 && <div className="col-md-12">
                              <div className="col-md-12">
                                <div className="col-md-2 margin-top-14px">
                                  <label htmlFor="">
                                    {" "}
                                    Playing Style
                                  </label>
                                </div>
                                <div className="col-md-8">
                                  <div
                                    className={`roleclass form-group text-box-margin ${isTabletOrMobile || isPortrait
                                      ? "row"
                                      : null
                                      }`}
                                  >
                                    <div className="" >
                                      <img onClick={() => setisbat(!isbat)} src={bat} alt="" style={batstyle} />
                                    </div>
                                    <div className="" >
                                      <img onClick={() => setisbol(!isbol)} src={ball} alt="" style={bolstyle} />
                                    </div>
                                    <div className="">
                                      <img onClick={() => setiswkeep(!iswkeep)} src={wkeeper} alt="" style={wkeepstyle} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>}

                            <div className="col-md-12 margin-top-14px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4">
                                    <label htmlFor="spcf1">
                                      {" "}
                                      Specification 1{" "}
                                    </label>
                                  </div>
                                  {auctype != 0 ?
                                    <div className="col-md-8">
                                      {" "}
                                      <input
                                        placeholder="Specification 1"
                                        className="form-control"
                                        type="text"
                                        {...register("spcf1", {})}
                                      />
                                    </div>
                                    :
                                    <div className="col-md-6">
                                      {" "}
                                      <select
                                        className="form-control"
                                        id="spcf1"
                                        type="text"
                                        {...register("spcf1")}
                                        onChange={(e) => {
                                          if (e.target.value === "Other") {
                                            setOtherBatting(true);
                                          } else {
                                            setOtherBatting(false);
                                          }
                                          setBatting(e.target.value);
                                        }}
                                      >
                                        <option value={""}>--Specification 1--</option>
                                        {sp1opt.map((ele) => (
                                          <option value={ele}>
                                            {ele}
                                          </option>
                                        ))}
                                      </select>
                                      {errors.spcf1 && (
                                        <p className="text-error">
                                          {errors.spcf1.message}
                                        </p>
                                      )}
                                    </div>
                                  }
                                </div>
                              </div>
                              {otherBatting ? (
                                <div className="col-md-6">
                                  <div className="form-group text-box-margin">
                                    <div className="col-md-4">
                                      <label htmlFor="spcf2"> Other </label>
                                    </div>
                                    <div className="col-md-8">
                                      <input
                                        placeholder="Other"
                                        className="form-control"
                                        type="text"
                                        // {...register("spcf1")}
                                        onChange={(e) =>
                                          setother(e.target.value)
                                        }
                                        value={other}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="col-md-12 margin-top-14px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4">
                                    <label htmlFor="spcf2">
                                      {" "}
                                      Specification 2{" "}
                                    </label>
                                  </div>
                                  {auctype != 0 ?
                                    <div className="col-md-8">
                                      {" "}
                                      <input
                                        placeholder="Specification 2"
                                        className="form-control"
                                        type="text"
                                        {...register("spcf2", {})}
                                      />
                                    </div>
                                    :
                                    <div className="col-md-6">
                                      {" "}
                                      <select
                                        className="form-control"
                                        id="spcf2"
                                        type="text"
                                        {...register("spcf2")}
                                        onChange={(e) => {
                                          if (e.target.value === "Other") {
                                            setOtherBowling(true);
                                          } else {
                                            setOtherBowling(false);
                                          }
                                          setBowling(e.target.value);
                                        }}
                                        value={bowling}
                                      >
                                        <option value={""}>--Specification 2--</option>
                                        {(batting == 'Bowling All Rounder' || batting == 'Bowler') ? sp3opt.map((ele) => (
                                          <option value={ele}>
                                            {ele}
                                          </option>
                                        )) : sp2opt.map((ele) => (
                                          <option value={ele}>
                                            {ele}
                                          </option>
                                        ))}

                                      </select>
                                      {errors.spcf2 && (
                                        <p className="text-error">
                                          {errors.spcf2.message}
                                        </p>
                                      )}
                                    </div>
                                  }
                                </div>
                              </div>
                              {otherBowling ? (
                                <div className="col-md-6">
                                  <div className="form-group text-box-margin">
                                    <div className="col-md-4">
                                      <label htmlFor="spcf2"> Other </label>
                                    </div>
                                    <div className="col-md-8">
                                      <input
                                        placeholder="Other"
                                        className="form-control"
                                        // {...register("spcf2")}
                                        type="text"
                                        onChange={(e) =>
                                          setother2(e.target.value)
                                        }
                                        value={other2}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="col-md-12 margin-top-14px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4">
                                    <label htmlFor="spcf1">
                                      {" "}
                                      Specification 3{" "}
                                    </label>
                                  </div>
                                  {auctype != 0 ?
                                    <div className="col-md-8">
                                      {" "}
                                      <input
                                        placeholder="Specification 3"
                                        className="form-control"
                                        type="text"
                                        {...register("spcf3", {})}
                                      />
                                    </div>
                                    :
                                    <div className="col-md-6">
                                      {" "}
                                      <select
                                        className="form-control"
                                        id="spcf3"
                                        type="text"
                                        {...register("spcf3", {
                                          required: false,
                                          // required: "required field.",
                                        })}
                                        onChange={(e) => {
                                          if (e.target.value === "Other") {
                                            setOthersp3(true);
                                          } else {
                                            setOthersp3(false);
                                          }
                                          setsp3(e.target.value);
                                        }}
                                        value={sp3}
                                      >
                                        <option value={""}>--Specification 3--</option>
                                        {(batting == 'Bowling All Rounder' || batting == 'Bowler') ? sp2opt.map((ele) => (
                                          <option value={ele}>
                                            {ele}
                                          </option>
                                        )) : sp3opt.map((ele) => (
                                          <option value={ele}>
                                            {ele}
                                          </option>
                                        ))}


                                      </select>
                                      {errors.spcf2 && (
                                        <p className="text-error">
                                          {errors.spcf2.message}
                                        </p>
                                      )}
                                    </div>
                                  }
                                </div>
                              </div>
                              {othersp3 ? (
                                <div className="col-md-6">
                                  <div className="form-group text-box-margin">
                                    <div className="col-md-4">
                                      <label htmlFor="spcf2"> Other </label>
                                    </div>
                                    <div className="col-md-8">
                                      <input
                                        placeholder="Other"
                                        className="form-control"
                                        // {...register("spcf2")}
                                        type="text"
                                        onChange={(e) =>
                                          setother3(e.target.value)
                                        }
                                        value={other3}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>

                            <div className="col-md-12 margin-top-14px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4">
                                    {" "}
                                    <label htmlFor="tshirt">
                                      {" "}
                                      T-shirt size{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <select
                                      className="form-control"
                                      type="text"
                                      id="tshirt"
                                      {...register("tshirt", {})}
                                    >
                                      <option value="">--select--</option>
                                      <option value="S">S</option>
                                      <option value="M">M</option>
                                      <option value="L">L</option>
                                      <option value="XL">XL</option>
                                      <option value="XXL">XXL</option>
                                      <option value="XXXL">XXXL</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4">
                                    {" "}
                                    <label htmlFor="tshirt"> Jersey Name</label>
                                  </div>
                                  <div className="col-md-8">
                                    {" "}
                                    <input
                                      placeholder="Jersey Name"
                                      className="form-control"
                                      type="text"
                                      {...register("jrnm", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px">
                              <div className="col-md-6">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4">
                                    <label htmlFor="jrno">
                                      {" "}
                                      Jersey Number{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    <input
                                      placeholder="Jersey Number"
                                      className="form-control"
                                      type="number"
                                      {...register("jrno", {})}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-4">
                                    <label htmlFor="trouser">
                                      {" "}
                                      Trouser Size{" "}
                                    </label>
                                  </div>
                                  <div className="col-md-8">
                                    <select
                                      className="form-control"
                                      id="trouser"
                                      type="text"
                                      {...register("trouser", {})}
                                    >
                                      <option value="">--select--</option>
                                      <option value="S">S</option>
                                      <option value="M">M</option>
                                      <option value="L">L</option>
                                      <option value="XL">XL</option>
                                      <option value="XXL">XXL</option>
                                      <option value="XXXL">XXXL</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 margin-top-14px">
                              {" "}
                              <div className="col-md-12">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-2">
                                    <label htmlFor="detail"> Detail </label>
                                  </div>
                                  <div className="col-md-8 margin-left-6px">
                                    <input
                                      className="form-control"
                                      placeholder="Details"
                                      type="text"
                                      id="detail"
                                      {...register("detail")}
                                    />

                                    {errors.detail && (
                                      <p className="text-error">
                                        {errors.detail.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 margin-top-14px">
                              <div className="col-md-12">
                                <div className="form-group text-box-margin">
                                  <div className="col-md-2">
                                    <label htmlFor="jrno"> Base Value </label>
                                  </div>
                                  <div className="col-md-3 margin-left-6px">
                                    <input
                                      placeholder="Base Value"
                                      className="form-control"
                                      type="number"
                                      step="any"
                                      {...register("base", {})}
                                    />
                                  </div>
                                  <div className="col-md-5">
                                    (If different from Minimum Base or Category
                                    Base Value)
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-12">
                              <button
                                className="button"
                                type="submit"
                                style={{
                                  marginLeft: "24px",
                                  borderRadius: "8px",
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Editplayers;
